<p-button
  [label]="label"
  [size]="size"
  [outlined]="outlined"
  [rounded]="rounded"
  [raised]="true"
  [severity]="severity"
  [styleClass]="styleClass"
  (onClick)="buttonFunction()">
  <ng-template pTemplate="content">
    <span
      class="p-button-label flex gap-3 align-content-center align-items-center">
      <i class="p-button-icon" [class]="icon"></i>
      @if (label) {
        <span class="mr-3">{{ label }}</span>
      }
      <span
        class="hidden sm:flex gap-1 align-items-center"
        [innerHTML]="keySuffix"></span>
    </span>
  </ng-template>
</p-button>
